import React from 'react';
import { useTranslation } from 'react-i18next';

function ExtraInfoHeaderCell() {
  const { t } = useTranslation();
  return <div className="promo-extra-info">{t('Deepest past discount')}</div>;
}

export default ExtraInfoHeaderCell;
